import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const presupuestoImporterSelectors = importerSelectors(
  'presupuesto.importer',
);

export default presupuestoImporterSelectors;
